module.exports = __webpack_public_path__ + "static/img/WILL-ELLIOT.bbff6eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-ELLIOT.jpg
// module id = o0MO
// module chunks = 0